import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';

import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import Messages from '../../../shared/UI/Messages/Messages';

import { Toast } from 'primereact/toast';
import jsPDF from 'jspdf';
import ChenthoorLogo from '../../../assets/images/Chenthoor_landscape_Logo-removebg-preview.png';
import axios from '../../../axios-url';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, POSITION_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

// ---- SOP editor helpers ----
// SOP values are now stored as HTML (from the rich text editor). Older records hold plain text,
// so these helpers convert in both directions.
const looksLikeHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(value || '');

const escapeHtml = (value) => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

// Plain text (old records) -> HTML paragraphs so line breaks survive in the editor
const toEditorHtml = (value) => {
    if (!value) { return ''; }
    if (looksLikeHtml(value)) { return value; }
    return String(value).split(/\r?\n/).map(line => '<p>' + (escapeHtml(line) || '<br>') + '</p>').join('');
};

// Editor HTML -> plain text with line breaks and list markers, used for the PDF
const htmlToPlainText = (value) => {
    if (!value) { return ''; }
    if (!looksLikeHtml(value)) { return String(value); }
    let container = document.createElement('div');
    container.innerHTML = value;
    let lines = [];
    container.childNodes.forEach(node => {
        if (node.nodeName === 'UL' || node.nodeName === 'OL') {
            Array.from(node.children).forEach((li, i) => {
                lines.push((node.nodeName === 'OL' ? (i + 1) + '. ' : '- ') + li.textContent);
            });
        } else {
            lines.push(node.textContent);
        }
    });
    return lines.join('\n').replace(/\u00a0/g, ' ').trim();
};

class AddPosition extends Component {
    state = {
        type: 'add',
        Id: null,
        PositionId: null,
        PositionNo: '',
        Name: '',
        Description: '',
        JobId: null,
        ReportedTo: null,
        SectionId: null,
        PositionType: null,
        keyResponsibilities: '',
        IsActive: true,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false,
        loading: false,
        positionRoles: [{ uid: 'row_1', RoleId: null, Responsibilities: [{ uid: 'row_2', ResponsibilityId: null }] }],
        resRolesResponsibilitiesList: [],
        RecordSopTamil: '',
        RecordSopEnglish: ''
    }

    rowUidCounter = 0;

    genUid = () => {
        this.rowUidCounter += 1;
        return 'row_' + this.rowUidCounter;
    }

    createResponsibility = () => {
        return { uid: this.genUid(), ResponsibilityId: null };
    }

    createRole = () => {
        return { uid: this.genUid(), RoleId: null, Responsibilities: [this.createResponsibility()] };
    }

    componentDidMount() {

        this.props.getMasterTableList('GetPosition');

        this.props.getMasterKeywordList('Job');
        this.props.getMasterKeywordList('Role');
        this.props.getMasterKeywordList('resRolesandResponsibility');

        this.getAccess = HASACCESS(POSITION_SUBMENU_ID);
        this.props.fetchPositionLists();
        let type = this.props.match.params.type;
        if (type !== 'add') {
            this.setState({ type: type });
            this.fetchPositionById();
        }
    }

    componentDidUpdate(prevProps) {
        let prev = prevProps.match.params;
        let curr = this.props.match.params;
        if ((prev.id !== curr.id || prev.type !== curr.type) && curr.type !== 'add') {
            this.setState({ type: curr.type });
            this.fetchPositionById();
        }
    }


    fetchPositionById = () => {
        let id = this.props.match.params.id;

        // Clear any previous values so stale data never survives a null in the response
        this.setState({
            loading: true,
            Id: null, PositionId: null, PositionNo: '', SectionId: null, PositionType: null,
            JobId: null, ReportedTo: null, Name: '', Description: '', IsActive: null,
            CompanyId: null, RecordSopTamil: '', RecordSopEnglish: '', touch: false
        });

        axios.get(`/master/api/getposition?Id=${id}`)
            .then(response => {
                if (response.status === 200 && response.data) {
                    // API wraps the record: { position: null, positionList: [ {...} ] }
                    let body = response.data;
                    let record = (Array.isArray(body.positionList) && body.positionList.length > 0)
                        ? body.positionList[0]
                        : (body.position || (body.id !== undefined ? body : null));

                    if (!record) {
                        this.setState({ loading: false });
                        return;
                    }

                    let filterData = { ...record };
                    if (filterData.positionRoles === undefined) { filterData.positionRoles = body.positionRoles; }
                    if (filterData.resRolesResponsibilitiesList === undefined) { filterData.resRolesResponsibilitiesList = body.resRolesResponsibilitiesList; }

                    // Always overwrite every field from the latest response; null/undefined clears the field
                    var data = {
                        Id: filterData.id ?? null,
                        PositionId: filterData.positionId ?? null,
                        PositionNo: filterData.positionNo ?? '',
                        SectionId: filterData.sectionId ?? null,
                        PositionType: filterData.positionType ?? null,
                        JobId: filterData.jobId ?? null,
                        ReportedTo: filterData.reportedTo ?? null,
                        Name: filterData.name ?? '',
                        Description: filterData.description ?? '',
                        IsActive: filterData.isactive ?? null,
                        CompanyId: filterData.companyId ?? null,
                        createdBy: filterData.createdby ?? null,
                        createdDate: filterData.createddate ?? null,
                        RecordSopTamil: filterData.soptamil ?? body.soptamil ?? '',
                        RecordSopEnglish: filterData.sopenglish ?? body.sopenglish ?? '',
                        touch: false,
                        positionRoles: (filterData.positionRoles && filterData.positionRoles.length > 0)
                            ? filterData.positionRoles.map(role => ({
                                uid: role.uid ?? this.genUid(),
                                RoleId: role.RoleId ?? role.roleId ?? null,
                                Responsibilities: ((role.Responsibilities || role.responsibilities) || []).map(res => ({
                                    uid: res.uid ?? this.genUid(),
                                    ResponsibilityId: res.ResponsibilityId ?? res.responsibilityId ?? null
                                }))
                            }))
                            : (Array.isArray(filterData.resRolesResponsibilitiesList) && filterData.resRolesResponsibilitiesList.length > 0)
                                // No saved role rows: rebuild the responsibility rows from the saved responsibility list
                                ? [{ uid: this.genUid(), RoleId: null, Responsibilities: filterData.resRolesResponsibilitiesList.map(r => ({ uid: this.genUid(), ResponsibilityId: r.roleResponsibilityId ?? null })) }]
                                : [this.createRole()],
                        resRolesResponsibilitiesList: filterData.resRolesResponsibilitiesList || [],
                        loading: false
                    }

                    this.setState(data);
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                if (this.growl) {
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed to fetch position details' });
                }
            });
    }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true })

    }

    addRole = () => {
        let newRoles = [...this.state.positionRoles, this.createRole()];
        this.setState({ positionRoles: newRoles, touch: true });
    }

    removeRole = (e, roleIndex) => {
        e.preventDefault();
        let updatedRoles = this.state.positionRoles.filter((role, index) => index !== roleIndex);
        this.setState({ positionRoles: updatedRoles, touch: true });
    }

    updateRole = (e, roleIndex) => {
        let { name, value } = e.target;
        let updatedRoles = [...this.state.positionRoles];
        updatedRoles[roleIndex] = { ...updatedRoles[roleIndex], [name]: value };
        this.setState({ positionRoles: updatedRoles, touch: true });
    }

    addResponsibility = (e, roleIndex) => {
        e.preventDefault();
        let updatedRoles = [...this.state.positionRoles];
        let responsibilities = [...updatedRoles[roleIndex].Responsibilities, this.createResponsibility()];
        updatedRoles[roleIndex] = { ...updatedRoles[roleIndex], Responsibilities: responsibilities };
        this.setState({ positionRoles: updatedRoles, touch: true });
    }

    removeResponsibility = (e, roleIndex, respIndex) => {
        e.preventDefault();
        let updatedRoles = [...this.state.positionRoles];
        let responsibilities = updatedRoles[roleIndex].Responsibilities.filter((res, index) => index !== respIndex);
        updatedRoles[roleIndex] = { ...updatedRoles[roleIndex], Responsibilities: responsibilities };
        this.setState({ positionRoles: updatedRoles, touch: true });
    }

    updateResponsibility = (e, roleIndex, respIndex) => {
        let { name, value } = e.target;
        let updatedRoles = [...this.state.positionRoles];
        let responsibilities = [...updatedRoles[roleIndex].Responsibilities];
        responsibilities[respIndex] = { ...responsibilities[respIndex], [name]: value };
        updatedRoles[roleIndex] = { ...updatedRoles[roleIndex], Responsibilities: responsibilities };
        this.setState({ positionRoles: updatedRoles, touch: true });
    }

    // Adapts the Editor's onTextChange ({ htmlValue, textValue, source }) to updateResponsibility.
    // Some PrimeReact versions pass Quill's old-contents Delta in `source` instead of 'user'/'api',
    // so only a real 'api'/'silent' string is skipped. Unchanged content (e.g. the editor echoing a
    // loaded value) is ignored so opening a row doesn't mark the form as changed.
    updateResponsibilityEditor = (field, existingKey, roleIndex, respIndex) => (e) => {
        if (typeof e.source === 'string' && e.source !== 'user') { return; }
        let value = e.htmlValue || '';
        let role = this.state.positionRoles[roleIndex];
        let row = role && role.Responsibilities ? role.Responsibilities[respIndex] : null;
        if (!row) { return; }
        if (value === toEditorHtml(this.getResponsibilityText(row, field, existingKey))) { return; }
        this.updateResponsibility({ target: { name: field, value: value } }, roleIndex, respIndex);
    }

    toggleResponsibility = (e, roleIndex, respIndex) => {
        e.preventDefault();
        let updatedRoles = [...this.state.positionRoles];
        let responsibilities = [...updatedRoles[roleIndex].Responsibilities];
        responsibilities[respIndex] = { ...responsibilities[respIndex], expanded: !responsibilities[respIndex].expanded };
        updatedRoles[roleIndex] = { ...updatedRoles[roleIndex], Responsibilities: responsibilities };
        this.setState({ positionRoles: updatedRoles });
    }

    // Row value if the user has typed one, otherwise the value loaded with the record
    // (from the matching responsibility entry, or from the position record itself when the API returns it there)
    getResponsibilityText = (rowData, field, existingKey) => {
        if (rowData[field] !== undefined) { return rowData[field]; }
        let existing = (this.state.resRolesResponsibilitiesList || []).find(r => r.roleResponsibilityId === rowData.ResponsibilityId);
        let recordValue = (existingKey === 'soptamil') ? this.state.RecordSopTamil : this.state.RecordSopEnglish;
        return (existing && existing[existingKey]) || recordValue || '';
    }

    responsibilityCellTemplate = (rowData, column, roleIndex) => {
        let expanded = rowData.expanded === true;
        return (
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button type="button" icon={expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'} className="p-button-secondary" style={{ marginRight: '0.5em' }} title={expanded ? 'Collapse' : 'Expand'} onClick={(e) => this.toggleResponsibility(e, roleIndex, column.rowIndex)} />
                    <Dropdown key={rowData.uid} id={`resp-dd-${rowData.uid}`} className="p-col-12" style={{ flex: 1 }} value={rowData.ResponsibilityId} options={this.props.Responsibilities} onChange={(e) => this.updateResponsibility(e, roleIndex, column.rowIndex)} name="ResponsibilityId" placeholder="Select Responsibility"
                        {...DROPDOWN_CONFIG} />
                </div>
                {expanded && (
                    <div style={{ marginTop: '0.5em' }}>
                        <label className="label">SOP Tamil</label>
                        <div className="mt1">
                            <Editor key={rowData.uid + '-sop-tamil'} style={{ height: '320px' }} placeholder="SOP Tamil"
                                value={toEditorHtml(this.getResponsibilityText(rowData, 'SopTamil', 'soptamil'))}
                                onTextChange={this.updateResponsibilityEditor('SopTamil', 'soptamil', roleIndex, column.rowIndex)} />
                        </div>

                        <label className="label" style={{ display: 'block', marginTop: '1em' }}>SOP English</label>
                        <div className="mt1">
                            <Editor key={rowData.uid + '-sop-english'} style={{ height: '320px' }} placeholder="SOP English"
                                value={toEditorHtml(this.getResponsibilityText(rowData, 'SopEnglish', 'sopenglish'))}
                                onTextChange={this.updateResponsibilityEditor('SopEnglish', 'sopenglish', roleIndex, column.rowIndex)} />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    responsibilityActionTemplate = (rowData, column, roleIndex, totalRows) => {
        return (
            <Button icon="pi pi-trash" className="p-button-danger" disabled={totalRows <= 1} onClick={(e) => this.removeResponsibility(e, roleIndex, column.rowIndex)} />
        );
    }

    downloadPdf = () => {
        // Logo is converted to a data URL so jsPDF can embed it; the PDF is still produced if it fails to load
        let img = new Image();
        img.onload = () => {
            let canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            canvas.getContext('2d').drawImage(img, 0, 0);
            this.buildPdf({ data: canvas.toDataURL('image/png'), ratio: img.naturalWidth / img.naturalHeight });
        };
        img.onerror = () => this.buildPdf(null);
        img.src = ChenthoorLogo;
    }

    buildPdf = (logo) => {
        const TEAL = [12, 107, 122];
        const GOLD = [242, 194, 27];
        const DARK = [33, 37, 41];
        const MUTED = [108, 117, 125];
        const CARD = [243, 248, 249];

        let labelOf = (options, value) => {
            let option = (options || []).find(o => o.value === value);
            return option ? option.label : '';
        };

        let doc = new jsPDF({ unit: 'mm', format: 'a4' });
        let pageWidth = doc.internal.pageSize.getWidth();
        let pageHeight = doc.internal.pageSize.getHeight();
        let margin = 15;
        let contentWidth = pageWidth - margin * 2;
        let bottomLimit = pageHeight - 20;
        let lineHeight = 4.8;
        let y = 0;

        // Renders wrapped text onto a canvas so the browser shapes Tamil correctly; sized in mm to match the PDF text
        let tamilTextImage = (text, widthMm, lineMm) => {
            let scale = 12; // canvas px per mm
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            let fontPx = lineMm * scale * 0.72;
            let font = fontPx + 'px "Noto Sans Tamil", "Nirmala UI", Latha, Catamaran, sans-serif';
            let widthPx = Math.round(widthMm * scale);
            ctx.font = font;

            let lines = [];
            text.split(/\r?\n/).forEach(paragraph => {
                let current = '';
                paragraph.split(/\s+/).forEach(word => {
                    let test = current ? current + ' ' + word : word;
                    if (current && ctx.measureText(test).width > widthPx) {
                        lines.push(current);
                        current = word;
                    } else {
                        current = test;
                    }
                });
                lines.push(current);
            });

            canvas.width = widthPx;
            canvas.height = Math.round(lines.length * lineMm * scale);
            ctx.font = font;
            ctx.fillStyle = '#212529';
            ctx.textBaseline = 'middle';
            lines.forEach((line, i) => ctx.fillText(line, 0, (i + 0.5) * lineMm * scale));
            return { data: canvas.toDataURL('image/png'), height: lines.length * lineMm };
        };

        let setColor = (c) => doc.setTextColor(c[0], c[1], c[2]);
        let setFill = (c) => doc.setFillColor(c[0], c[1], c[2]);

        // Header band with the logo on the first page
        setFill(TEAL);
        doc.rect(0, 0, pageWidth, 34, 'F');
        setFill(GOLD);
        doc.rect(0, 34, pageWidth, 1.5, 'F');
        if (logo) {
            let logoHeight = 22;
            let logoWidth = logoHeight * logo.ratio;
            doc.addImage(logo.data, 'PNG', (pageWidth - logoWidth) / 2, 6, logoWidth, logoHeight);
        }
        y = 46;

        let newPage = () => {
            doc.addPage();
            setFill(TEAL);
            doc.rect(0, 0, pageWidth, 8, 'F');
            setFill(GOLD);
            doc.rect(0, 8, pageWidth, 0.8, 'F');
            y = 18;
        };

        let ensureSpace = (height) => {
            if (y + height > bottomLimit) { newPage(); }
        };

        let sectionHeading = (title) => {
            ensureSpace(14);
            setFill(GOLD);
            doc.rect(margin, y - 4.5, 1.8, 6.5, 'F');
            setColor(TEAL);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text(title.toUpperCase(), margin + 4.5, y);
            y += 3;
            doc.setDrawColor(220, 226, 229);
            doc.line(margin, y, pageWidth - margin, y);
            y += 7;
        };

        // Small grey caption above a bold value, wrapped to the given width
        let field = (label, value, x, width) => {
            setColor(MUTED);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(label.toUpperCase(), x, y);
            setColor(DARK);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10.5);
            let lines = doc.splitTextToSize(String(value || '-'), width);
            doc.text(lines, x, y + 5);
            return 5 + lines.length * lineHeight;
        };

        // Title card: position name, number and status badge
        let hasStatus = this.state.IsActive !== null && this.state.IsActive !== undefined;
        let isActive = this.state.IsActive === true;
        setFill(CARD);
        doc.roundedRect(margin, y - 6, contentWidth, 22, 2, 2, 'F');
        setFill(TEAL);
        doc.rect(margin, y - 6, 2.2, 22, 'F');
        setColor(TEAL);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(15);
        let titleLines = doc.splitTextToSize(this.state.Name || '-', contentWidth - 50);
        doc.text(titleLines[0], margin + 7, y + 7);
        if (hasStatus) {
            let badgeWidth = 24;
            setFill(isActive ? [40, 167, 69] : [220, 53, 69]);
            doc.roundedRect(pageWidth - margin - badgeWidth - 5, y + 1, badgeWidth, 8, 4, 4, 'F');
            setColor([255, 255, 255]);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(9);
            doc.text(isActive ? 'ACTIVE' : 'INACTIVE', pageWidth - margin - badgeWidth / 2 - 5, y + 6.2, { align: 'center' });
        }
        y += 26;

        // Details in a two-column grid
        sectionHeading('Position Details');
        let colWidth = (contentWidth - 10) / 2;
        let col2 = margin + colWidth + 10;

        let h2 = Math.max(field('Job', labelOf(this.props.Jobs, this.state.JobId), margin, colWidth), field('Reporting To', labelOf(this.props.positionList, this.state.ReportedTo), col2, colWidth));
        y += h2 + 5;
        doc.setFontSize(10.5);
        doc.setFont('helvetica', 'normal');
        let descLines = doc.splitTextToSize(String(this.state.Description || '-'), contentWidth);
        ensureSpace(5 + descLines.length * lineHeight);
        let h3 = field('Description', this.state.Description, margin, contentWidth);
        y += h3 + 8;

        // Responsibilities as cards
        let responsibilities = [];
        (this.state.positionRoles || []).forEach(role => {
            (role.Responsibilities || []).forEach(res => {
                if (res.ResponsibilityId) { responsibilities.push(res); }
            });
        });

        if (responsibilities.length > 0) {
            sectionHeading('Responsibilities');
            let innerX = margin + 12;
            let innerWidth = contentWidth - 16;

            responsibilities.forEach((res, index) => {
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(11);
                let title = doc.splitTextToSize(labelOf(this.props.Responsibilities, res.ResponsibilityId) || '-', innerWidth);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10.5);
                // SOP values are editor HTML; convert to plain text (keeping line breaks and list markers) for the PDF
                let sopTamilText = htmlToPlainText(this.getResponsibilityText(res, 'SopTamil', 'soptamil'));
                let sopEnglishText = htmlToPlainText(this.getResponsibilityText(res, 'SopEnglish', 'sopenglish'));
                // Tamil is drawn as an image: the built-in PDF fonts have no Tamil glyphs
                let tamil = tamilTextImage(sopTamilText || '-', innerWidth, lineHeight);
                let englishLines = doc.splitTextToSize(sopEnglishText || '-', innerWidth);
                let cardHeight = 6 + title.length * lineHeight + 4 + (5 + tamil.height) + 3 + (5 + englishLines.length * lineHeight) + 4;

                ensureSpace(Math.min(cardHeight, bottomLimit - 18));
                let top = y;
                setFill(CARD);
                doc.roundedRect(margin, top, contentWidth, cardHeight, 2, 2, 'F');

                setFill(TEAL);
                doc.circle(margin + 6, top + 7.5, 3.4, 'F');
                setColor([255, 255, 255]);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(9);
                doc.text(String(index + 1), margin + 6, top + 8.8, { align: 'center' });

                setColor(TEAL);
                doc.setFontSize(11);
                doc.text(title, innerX, top + 8.5);
                let cy = top + 6 + title.length * lineHeight + 4;

                setColor(MUTED);
                doc.setFontSize(8);
                doc.text('SOP TAMIL', innerX, cy + 1);
                if (tamil.data) { doc.addImage(tamil.data, 'PNG', innerX, cy + 2.5, innerWidth, tamil.height); }
                cy += 5 + tamil.height + 3;

                setColor(MUTED);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(8);
                doc.text('SOP ENGLISH', innerX, cy + 1);
                setColor(DARK);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10.5);
                doc.text(englishLines, innerX, cy + 5.5);

                y = top + cardHeight + 5;
            });
        }

        // Footer on every page
        let totalPages = doc.internal.getNumberOfPages();
        let generated = new Date().toLocaleString('en-GB');
        for (let p = 1; p <= totalPages; p++) {
            doc.setPage(p);
            setFill(GOLD);
            doc.rect(margin, pageHeight - 14, contentWidth, 0.6, 'F');
            setColor(MUTED);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.text('Chenthoor - Pure Veg  |  Generated on ' + generated, margin, pageHeight - 9);
            doc.text('Page ' + p + ' of ' + totalPages, pageWidth - margin, pageHeight - 9, { align: 'right' });
        }

        let fileName = 'Position_' + (this.state.PositionNo || this.state.Name || 'Details').toString().replace(/[^\w\-]+/g, '_') + '.pdf';
        doc.save(fileName);
    }

    add = () => {

        if (this.state.PositionNo === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Position no is required' });
            return;
        } else if (this.state.Name === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Position name is required' });
            return;
        } else if (this.state.JobId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'JobId is required' });
            return;
        } else if (this.state.ReportedTo === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'ReportedTo is required' });
            return;
        }


        let isEdit = (this.state.type === 'edit');

        var position = {
            ...(isEdit && { id: this.state.Id, positionId: this.state.PositionId }),
            positionNo: this.state.PositionNo,
            ...(isEdit && { sectionId: this.state.SectionId ?? null }),
            jobId: this.state.JobId,
            positionType: this.state.PositionType ?? null,
            reportedTo: this.state.ReportedTo,
            name: this.state.Name,
            description: this.state.Description || null,
            isdivision: null,
            isdepartment: null,
            issection: null,
            isemployee: null,
            isactive: this.state.IsActive,
            createdby: this.state.createdBy,
            createddate: this.state.createdDate,
            updatedby: isEdit ? ((this.props.loggedUserDetail.userName) ?? 'Admin') : null,
            updateddate: isEdit ? new Date() : null,
            companyId: this.state.CompanyId
        }

        let selectedResponsibilityIds = [];
        let responsibilityRows = {};
        (this.state.positionRoles || []).forEach(role => {
            (role.Responsibilities || []).forEach(res => {
                if (res.ResponsibilityId) {
                    selectedResponsibilityIds.push(res.ResponsibilityId);
                    if (!responsibilityRows[res.ResponsibilityId]) { responsibilityRows[res.ResponsibilityId] = res; }
                }
            });
        });
        selectedResponsibilityIds = [...new Set(selectedResponsibilityIds)];

        var resRolesResponsibilitiesList = selectedResponsibilityIds.map(id => {
            let option = (this.props.Responsibilities || []).find(r => r.value === id);
            let existing = (this.state.resRolesResponsibilitiesList || []).find(r => r.roleResponsibilityId === id);
            let row = responsibilityRows[id] || {};
            return {
                roleResponsibilityId: id,
                department: existing ? existing.department : null,
                position: this.state.Name,
                jobPurpose: existing ? existing.jobPurpose : null,
                soptamil: row.SopTamil !== undefined ? (row.SopTamil || null) : (existing ? existing.soptamil : null),
                keyResponsibilities: existing ? existing.keyResponsibilities : ((option && option.label) || this.state.keyResponsibilities || null),
                suggestedKpis: existing ? existing.suggestedKpis : null,
                sopenglish: row.SopEnglish !== undefined ? (row.SopEnglish || null) : (existing ? existing.sopenglish : null),
                reportsTo: existing ? existing.reportsTo : null,
                isActive: existing ? existing.isActive : true,
                createdOn: existing ? existing.createdOn : new Date(),
                ...(isEdit && { departmentid: existing ? existing.departmentid : null }),
                ...(isEdit && { positionId: this.state.PositionId })
            };
        });

        var data = {
            position: position,
            positionList: null,
            resRolesResponsibilitiesList: resRolesResponsibilitiesList
        }

        let url = isEdit ? '/master/api/UpdateDynamicData?model=Position' : '/master/api/InsertDynamicData?model=Position';
        let message = isEdit ? 'Updated Successfully' : 'Added Successfully';

        this.setState({ loading: true });

        // Backend (CommonAddMethod) reads the JSON string from the "Key" property
        var payload = { Key: JSON.stringify(data) };

        axios.post(url, JSON.stringify(payload))
            .then(response => {
                this.setState({ loading: false });
                if (response.data && response.data.statusCode === 1) {
                    localStorage.removeItem('GetPosition');
                    this.growl.show({ severity: 'success', summary: null, detail: message });
                    setTimeout(() => {
                        REDIRECT_TO_URL('/position-master/', this.props);
                    }, 1000);
                } else {
                    this.growl.show({ severity: 'error', summary: null, detail: 'Process Api Error' });
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: (err && err.response && err.response.data) || 'Process Api Error' });
            });

    }

    resetData = () => {
        var data = {
            PositionNo: '',
            //JobId : this.state.JobId,
            ReportedTo: null,
            Name: '',
            Description: '',
            positionRoles: [],
        }
        this.setState(data);
    }


    render() {

        if (this.props.success) {
            REDIRECT_TO_URL('/position-master/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }


        let positionList = [];

        if (this.props.positionList && this.props.positionList.length > 0) {
            positionList = this.props.positionList;
        }

        let isEnabled = (this.state.touch === true);

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.state.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Position</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Position Number  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="PositionNo" value={this.state.PositionNo} onChange={this.change} placeholder="Position Number" />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Position Name  <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="Name" value={this.state.Name} onChange={this.change} placeholder="Position Name" />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Position Description </label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputTextarea rows={3} cols={30} className="width100" value={this.state.Description} onChange={this.change} name="Description" placeholder="Position Description" autoResize={true} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Job <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" value={this.state.JobId} options={this.props.Jobs} onChange={this.change} name="JobId" placeholder="Select Job"
                                        {...DROPDOWN_CONFIG} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Reporting To <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">

                                    <Dropdown placeholder="Select Reporting To" value={this.state.ReportedTo} name="ReportedTo" options={positionList} onChange={this.change} className="p-col-12" {...DROPDOWN_CONFIG} />

                                </div>

                            </div>

                            {/* Responsibilities, SOP editors and footer span the full width of the card */}
                            <div className="p-col-12">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Responsibility</label>
                                </div>

                                {this.state.positionRoles.map((role, roleIndex) => (
                                    <div className="p-col-12" key={role.uid}>
                                        <div className="p-grid">
                                            <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button label="Add Responsibility" icon="pi pi-plus" onClick={(e) => this.addResponsibility(e, roleIndex)} />
                                            </div>

                                            <div className="p-col-12">
                                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                    dataKey="uid" rows={10} value={role.Responsibilities} style={{ width: '100%' }}>
                                                    <Column header="Responsibility" body={(rowData, column) => this.responsibilityCellTemplate(rowData, column, roleIndex)} />
                                                    <Column header="Action" body={(rowData, column) => this.responsibilityActionTemplate(rowData, column, roleIndex, role.Responsibilities.length)} style={{ textAlign: 'center', width: '8em' }} />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="p-col-12">
                                    <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={"/position-master/"}>
                                        {this.state.type !== 'add' &&
                                            <Button type="button" label="PDF" icon="pi pi-file-pdf" className="ml1 p-button-secondary" style={{ float: 'right' }} onClick={this.downloadPdf} disabled={this.state.loading} />
                                        }
                                    </FooterButton>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}




const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        positionList: state.master.positionList,
        tableLists: state.master.tableLists,
        Jobs: (state.keyword.Job !== undefined) ? state.keyword.Job : [],
        Roles: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        Responsibilities: (state.keyword.resRolesandResponsibility !== undefined) ? state.keyword.resRolesandResponsibility : [],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        fetchPositionLists: () => dispatch(actions.fetchPositionLists()),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddPosition);